import React from "react";

const InsuranceProvider = ({
  onClickFn = () => {},
  width = "23",
  height = "20",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3246_136)">
<path d="M0 1.875C0 0.839844 0.839844 0 1.875 0H13.125C14.1602 0 15 0.839844 15 1.875V8.08594L13.3438 8.75H11.875H10.625C10.2812 8.75 10 9.03125 10 9.375V10.625V11.5703V11.875C10 11.9102 10.0039 11.9414 10.0078 11.9766C10.0977 14.2461 10.9492 17.6328 13.8633 19.8477C13.6367 19.9453 13.3867 20 13.125 20H9.375V16.875C9.375 15.8398 8.53516 15 7.5 15C6.46484 15 5.625 15.8398 5.625 16.875V20H1.875C0.839844 20 0 19.1602 0 18.125V1.875ZM3.125 8.75C2.78125 8.75 2.5 9.03125 2.5 9.375V10.625C2.5 10.9688 2.78125 11.25 3.125 11.25H4.375C4.71875 11.25 5 10.9688 5 10.625V9.375C5 9.03125 4.71875 8.75 4.375 8.75H3.125ZM6.25 9.375V10.625C6.25 10.9688 6.53125 11.25 6.875 11.25H8.125C8.46875 11.25 8.75 10.9688 8.75 10.625V9.375C8.75 9.03125 8.46875 8.75 8.125 8.75H6.875C6.53125 8.75 6.25 9.03125 6.25 9.375ZM2.5 4.375V5.625C2.5 5.96875 2.78125 6.25 3.125 6.25H4.375C4.71875 6.25 5 5.96875 5 5.625V4.375C5 4.03125 4.71875 3.75 4.375 3.75H3.125C2.78125 3.75 2.5 4.03125 2.5 4.375ZM6.875 3.75C6.53125 3.75 6.25 4.03125 6.25 4.375V5.625C6.25 5.96875 6.53125 6.25 6.875 6.25H8.125C8.46875 6.25 8.75 5.96875 8.75 5.625V4.375C8.75 4.03125 8.46875 3.75 8.125 3.75H6.875ZM10 4.375V5.625C10 5.96875 10.2812 6.25 10.625 6.25H11.875C12.2188 6.25 12.5 5.96875 12.5 5.625V4.375C12.5 4.03125 12.2188 3.75 11.875 3.75H10.625C10.2812 3.75 10 4.03125 10 4.375ZM16.5273 8.81641C16.75 8.72656 17 8.72656 17.2227 8.81641L21.9102 10.6914C22.2656 10.8359 22.5 11.1797 22.5 11.5625C22.5 14.0352 21.4883 18.1562 17.2344 19.9297C17.0039 20.0273 16.7422 20.0273 16.5117 19.9297C12.2617 18.1562 11.25 14.0352 11.25 11.5625C11.25 11.1797 11.4844 10.8359 11.8398 10.6914L16.5273 8.81641ZM20.6016 12.1875L16.875 10.6953V18.0352C19.5391 16.7461 20.4492 14.168 20.6016 12.1875Z" fill={fill}/>
</g>
<defs>
<clipPath id="clip0_3246_136">
<path d="M0 0H22.5V20H0V0Z" fill={fill}/>
</clipPath>
</defs>
    </svg>
  );
};

export default InsuranceProvider;